<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue', 'change']);

const onChange = event => {
  emit('update:modelValue', event.target.value);
  emit('change');
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <label class="inline-flex items-center gap-2 text-[13px] text-lais-text-body">
    <span class="font-semibold">Ordenar por:</span>
    <select
      :value="modelValue"
      class="rounded-full border border-lais-border bg-white px-3 py-1.5 text-[12px] font-semibold text-lais-text"
      @change="onChange"
    >
      <option
        v-for="option in options"
        :key="option.value || 'default'"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </label>
</template>
